
import React, { useEffect, useState } from 'react';
import { Boxes, ClassBody, InfinitySymbol } from './Theme';

const BulkClassBox = ({ classDetails,...props }) => {
    const [age, setAgeRange] = useState([]);

    useEffect(() => {
        setAgeRange([{ value: classDetails.class_details?.maximum_participants, desc: 'Max participants', infinity: classDetails?.class_details?.infiniteParticipants }, {
            value: `${classDetails.class_details?.ageStart}${classDetails.class_details?.ageEnd ? "-" + classDetails.class_details?.ageEnd : ''}`, desc: 'Max Age Range'
        }])
    }, [classDetails])


    return (
        <ClassBody steps={props?.steps}>
            <Boxes>
                {age.map((item, index) => (
                    <div key={index}>
                        {item.infinity ?
                            <InfinitySymbol>&#8734;</InfinitySymbol>
                            : item.value}
                        <span>{item.desc}</span>
                    </div>

                ))}
            </Boxes>
        </ClassBody >
    );
};

export default BulkClassBox;